<template>
    <aside class="editor-apresentacao" @click.stop>
        <header class="editor-cabecalho">
            <h3>Editar apresentação</h3>
            <button type="button" class="acao-secundaria btn-icone" title="Fechar editor" @click="$emit('fechar')">
                <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
        </header>

        <div class="editor-corpo">
            <div class="editor-secao">
                <div class="editor-secao-titulo">
                    <span>Slides</span>
                    <div class="editor-add-botoes">
                        <button type="button" class="acao-secundaria btn-mini" @click="adicionarSlide('texto')">
                            + Texto
                        </button>
                        <button type="button" class="acao-secundaria btn-mini" @click="adicionarSlideTabelaPainel">
                            + Tabela (painel)
                        </button>
                        <button type="button" class="acao-secundaria btn-mini" @click="adicionarSlideTabelaManual">
                            + Tabela (manual)
                        </button>
                        <button type="button" class="acao-secundaria btn-mini" @click="adicionarSlide('imagem')">
                            + Imagem
                        </button>
                    </div>
                </div>

                <draggable
                    v-model="slidesLocal"
                    item-key="id"
                    handle=".slide-drag-handle"
                    class="editor-lista-slides"
                    @end="onSlidesReordenados"
                >
                    <template #item="{ element, index }">
                        <div
                            class="editor-slide-item"
                            :class="{ 'editor-slide-item--ativo': slideAtivoIdx === index }"
                            @click.stop="selecionarSlide(index)"
                        >
                            <span class="slide-drag-handle" title="Arrastar para reordenar">
                                <i class="bi bi-grip-vertical" aria-hidden="true"></i>
                            </span>
                            <span class="editor-slide-resumo">
                                <strong>{{ index + 1 }}.</strong>
                                {{ element.titulo || tipoLabel(element.tipo) }}
                                <span v-if="resumoFonteSlide(element)" class="editor-slide-fonte">
                                    · {{ resumoFonteSlide(element) }}
                                </span>
                            </span>
                            <div class="editor-slide-acoes">
                                <button type="button" class="btn-icone" title="Duplicar" @click.stop="duplicarSlide(index)">
                                    <i class="bi bi-copy" aria-hidden="true"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn-icone btn-icone--perigo"
                                    title="Remover"
                                    @click.stop="removerSlide(index)"
                                >
                                    <i class="bi bi-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>

            <div v-if="slideAtivo" class="editor-secao editor-detalhe">
                <label :for="`slide-titulo-${slideAtivo.id}`">Título</label>
                <input
                    :id="`slide-titulo-${slideAtivo.id}`"
                    v-model="slideAtivo.titulo"
                    type="text"
                    placeholder="Título do slide"
                    @input="emitirAtualizacaoDebounced"
                />

                <template v-if="slideAtivo.tipo === 'capa'">
                    <label :for="`slide-sub-${slideAtivo.id}`">Subtítulo / período</label>
                    <input
                        :id="`slide-sub-${slideAtivo.id}`"
                        v-model="slideAtivo.subtitulo"
                        type="text"
                        placeholder="Ex.: 12/06/2026 – 16/06/2026"
                        @input="emitirAtualizacaoDebounced"
                    />
                </template>

                <template v-if="slideAtivo.tipo === 'texto'">
                    <label :for="`slide-corpo-${slideAtivo.id}`">Conteúdo (uma linha = um item)</label>
                    <textarea
                        :id="`slide-corpo-${slideAtivo.id}`"
                        v-model="slideAtivo.corpo"
                        rows="8"
                        placeholder="Digite cada item em uma linha"
                        @input="emitirAtualizacaoDebounced"
                    />
                </template>

                <template v-if="slideAtivo.tipo === 'tabela'">
                    <label>Origem dos dados</label>
                    <select v-model="slideAtivo.fonte" @change="onFonteChange">
                        <option value="dinamica">Dados do painel (atualiza automaticamente)</option>
                        <option value="manual">Lista manual (projeto e pacote de trabalho)</option>
                    </select>

                    <template v-if="slideAtivo.fonte === 'dinamica'">
                        <fieldset class="editor-bloco-painel">
                            <legend>Lista do painel</legend>
                            <p class="editor-hint editor-hint--bloco">
                                Escolha qual seção da Gestão de pacotes de trabalho alimenta este slide. Os dados atualizam automaticamente ao mudar o período ou filtros do painel.
                            </p>
                            <label
                                v-for="opcao in opcoesFonteDados"
                                :key="opcao.value"
                                class="editor-bloco-opcao"
                                :class="{ 'editor-bloco-opcao--ativa': slideAtivo.fonteDados === opcao.value }"
                            >
                                <input
                                    v-model="slideAtivo.fonteDados"
                                    type="radio"
                                    name="fonte-dados-painel"
                                    :value="opcao.value"
                                    @change="onFonteDadosChange"
                                />
                                <span class="editor-bloco-opcao-texto">
                                    <span class="editor-bloco-opcao-titulo">{{ opcao.label }}</span>
                                    <span class="editor-bloco-contagem">{{ contagemPainel(opcao.value) }} itens</span>
                                </span>
                            </label>
                        </fieldset>

                        <div class="editor-resumo-painel" role="status">
                            <i class="bi bi-table" aria-hidden="true"></i>
                            <span>
                                Este slide exibe <strong>{{ labelFonteDadosAtual }}</strong>
                                <template v-if="labelPeriodo"> · período {{ labelPeriodo }}</template>
                                — <strong>{{ contagemPainel(slideAtivo.fonteDados) }}</strong> registros agora
                            </span>
                        </div>
                    </template>

                    <template v-else>
                        <div v-if="itensSelecionados.length" class="editor-projetos-selecionados">
                            <p class="editor-projetos-label">Linhas no slide ({{ itensSelecionados.length }})</p>
                            <ul>
                                <li v-for="item in itensSelecionados" :key="item.id">
                                    <span>{{ item.rotulo }}</span>
                                    <button type="button" class="btn-icone btn-icone--perigo" @click="removerItem(item.id)">
                                        <i class="bi bi-x" aria-hidden="true"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <p v-else class="editor-hint editor-hint--vazio">Nenhuma linha adicionada ainda.</p>

                        <div class="editor-secao-adicionar">
                            <p class="editor-projetos-label">Adicionar à tabela</p>
                            <label for="editor-busca-projeto-apresentacao">Buscar projeto</label>
                            <div class="editor-busca-projeto">
                                <input
                                    id="editor-busca-projeto-apresentacao"
                                    v-model="termoBusca"
                                    type="search"
                                    placeholder="Nome ou código PCM"
                                    @input="buscarProjetosDebounced"
                                />
                                <div v-if="buscandoProjetos" class="editor-busca-hint">Buscando…</div>
                                <ul v-else-if="resultadosBusca.length" class="editor-resultados-busca">
                                    <li v-for="p in resultadosBusca" :key="p.id">
                                        <button type="button" class="acao-secundaria editor-resultado-btn" @click="adicionarProjeto(p)">
                                            <span>{{ p.pcm_codigo ? `${p.pcm_codigo} · ` : '' }}{{ p.nome }}</span>
                                            <i class="bi bi-plus-lg" aria-hidden="true"></i>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <ModalSelecionarEntregaApresentacao
                            :mostrar="!!modalEntregas?.aberto"
                            :pcm-codigo="modalEntregas?.pcm_codigo || ''"
                            :nome-projeto="modalEntregas?.nome || ''"
                            :entregas="modalEntregas?.entregas || []"
                            :carregando="!!modalEntregas?.carregando"
                            :permitir-sem-entrega="!precisaEntregaNasColunas"
                            :entregas-adicionadas="entregasAdicionadasNoModal"
                            :projeto-adicionado-sem-entrega="projetoSemEntregaNoModal"
                            @adicionar="onModalAdicionarEntrega"
                            @adicionar-projeto="onModalAdicionarProjeto"
                            @fechar="fecharModalEntregas"
                        />
                    </template>

                    <fieldset class="editor-colunas">
                        <legend>Colunas da tabela</legend>
                        <div class="editor-colunas-checkboxes">
                            <label
                                v-for="campo in colunasDisponiveis"
                                :key="campo"
                                class="editor-coluna-item"
                            >
                                <input
                                    type="checkbox"
                                    :checked="slideAtivo.colunas.includes(campo)"
                                    @change="toggleColuna(campo)"
                                />
                                {{ obterLabelColuna(campo) }}
                            </label>
                        </div>
                        <p v-if="slideAtivo.colunas.length" class="editor-projetos-label">Ordem das colunas</p>
                        <draggable
                            v-if="slideAtivo.colunas.length"
                            v-model="slideAtivo.colunas"
                            :item-key="(c) => c"
                            handle=".slide-drag-handle"
                            class="editor-colunas-ordenadas"
                            @end="emitirAtualizacao"
                        >
                            <template #item="{ element: campo }">
                                <div :key="campo" class="editor-coluna-ordenada">
                                    <span class="slide-drag-handle"><i class="bi bi-grip-vertical"></i></span>
                                    {{ obterLabelColuna(campo) }}
                                </div>
                            </template>
                        </draggable>
                        <p class="editor-hint">Marque as colunas e arraste a lista de ordem para reorganizar.</p>
                        <p v-if="slideAtivo.fonte === 'manual'" class="editor-hint">
                            Busque um projeto e escolha os pacotes de trabalho no modal. Você pode adicionar vários antes de concluir.
                        </p>
                    </fieldset>
                </template>

                <template v-if="slideAtivo.tipo === 'imagem'">
                    <label :for="`slide-img-${slideAtivo.id}`">Imagem (PNG, JPG ou WebP — máx. 2 MB)</label>
                    <input
                        :id="`slide-img-${slideAtivo.id}`"
                        type="file"
                        accept="image/png,image/jpeg,image/webp"
                        @change="onImagemSelecionada"
                    />
                    <div v-if="slideAtivo.imagemDataUrl" class="editor-img-preview">
                        <img :src="slideAtivo.imagemDataUrl" alt="Preview" />
                        <button type="button" class="acao-secundaria btn-mini" @click="removerImagem">
                            Remover imagem
                        </button>
                    </div>
                    <label :for="`slide-legenda-${slideAtivo.id}`">Legenda (opcional)</label>
                    <input
                        :id="`slide-legenda-${slideAtivo.id}`"
                        v-model="slideAtivo.imagemLegenda"
                        type="text"
                        @input="emitirAtualizacaoDebounced"
                    />
                    <label>Ajuste da imagem</label>
                    <select v-model="slideAtivo.imagemAjuste" @change="emitirAtualizacaoDebounced">
                        <option value="contain">Conter (sem cortar)</option>
                        <option value="cover">Preencher</option>
                    </select>
                </template>
            </div>
        </div>

        <footer class="editor-rodape">
            <button type="button" class="acao-secundaria" @click="restaurarPadrao">
                Restaurar slides padrão
            </button>
        </footer>
    </aside>
</template>

<script>
import draggable from 'vuedraggable'
import serviceProjetos from '@/services/serviceProjetos'
import ModalSelecionarEntregaApresentacao from './ModalSelecionarEntregaApresentacao.vue'
import {
    CATALOGO_COLUNAS,
    COLUNAS_PROJETO_PADRAO,
    COLUNAS_TABELA_PADRAO,
    colunasPrecisamEntrega,
    criarItemManual,
    criarSlideVazio,
    criarSlidesPadrao,
    gerarSlideId,
    labelColuna,
    labelFonteDados,
    lerArquivoComoDataUrl,
    normalizarSlideManual,
    obterItensManuaisSlide,
    OPCOES_FONTE_DADOS,
    sincronizarProjetoIdsSlide,
    tituloDeveSincronizarComFonte,
    tituloPadraoFonteDados,
    TIPOS_SLIDE_LABEL,
    validarImagemUpload,
} from '@/utils/apresentacaoGestaoEntregas'
import { labelPeriodoSemana } from '@/utils/sprintGestao'

const TODAS_COLUNAS = Object.keys(CATALOGO_COLUNAS)

export default {
    name: 'EditorApresentacaoGestao',

    components: { draggable, ModalSelecionarEntregaApresentacao },

    props: {
        slides: {
            type: Array,
            required: true,
        },
        periodoInicio: { type: String, default: '' },
        periodoFim: { type: String, default: '' },
        cacheProjetos: { type: Object, default: () => ({}) },
        cacheEntregas: { type: Object, default: () => ({}) },
        contagensPainel: {
            type: Object,
            default: () => ({
                'entregas-periodo': 0,
                fixadas: 0,
                atrasadas: 0,
                'sem-fim': 0,
            }),
        },
        slideAtivoIdx: { type: Number, default: 0 },
    },

    emits: ['atualizar', 'fechar', 'projeto-cache', 'entrega-cache', 'update:slideAtivoIdx'],

    data() {
        return {
            slidesLocal: [],
            termoBusca: '',
            resultadosBusca: [],
            buscandoProjetos: false,
            modalEntregas: null,
            debounceSave: null,
            debounceBusca: null,
            colunasDisponiveis: [...TODAS_COLUNAS],
            opcoesFonteDados: [...OPCOES_FONTE_DADOS],
        }
    },

    computed: {
        labelPeriodo() {
            return labelPeriodoSemana(this.periodoInicio, this.periodoFim)
        },

        labelFonteDadosAtual() {
            if (!this.slideAtivo || this.slideAtivo.fonte !== 'dinamica') return ''
            return labelFonteDados(this.slideAtivo.fonteDados)
        },
        slideAtivo() {
            return this.slidesLocal[this.slideAtivoIdx] || null
        },

        precisaEntregaNasColunas() {
            if (!this.slideAtivo || this.slideAtivo.tipo !== 'tabela') return false
            return colunasPrecisamEntrega(this.slideAtivo.colunas)
        },

        itensSelecionados() {
            if (!this.slideAtivo || this.slideAtivo.tipo !== 'tabela') return []
            const itens = obterItensManuaisSlide(this.slideAtivo)
            return itens.map((item) => {
                const projetoId = Number(item.projeto_id)
                const entregaId = item.entrega_id != null ? Number(item.entrega_id) : null
                const cached = this.cacheProjetos[projetoId]
                const pcm = cached?.pcm_codigo || ''
                const nomeProjeto = cached?.projeto_nome || cached?.nome || `Projeto #${projetoId}`
                let rotulo = pcm ? `${pcm} · ${nomeProjeto}` : nomeProjeto
                if (entregaId) {
                    const entrega = this.cacheEntregas[entregaId]
                    const nomeEntrega = entrega?.entrega_nome || `Pacote de trabalho #${entregaId}`
                    rotulo = `${rotulo} · ${nomeEntrega}`
                }
                return { id: item.id, rotulo }
            })
        },

        entregasAdicionadasNoModal() {
            const projetoId = Number(this.modalEntregas?.projetoId)
            if (!projetoId) return []
            return obterItensManuaisSlide(this.slideAtivo)
                .filter((item) => Number(item.projeto_id) === projetoId && item.entrega_id != null)
                .map((item) => Number(item.entrega_id))
        },

        projetoSemEntregaNoModal() {
            const projetoId = Number(this.modalEntregas?.projetoId)
            if (!projetoId) return false
            return this.itemJaAdicionado(projetoId, null)
        },
    },

    watch: {
        slides: {
            immediate: true,
            deep: true,
            handler(val) {
                const slides = JSON.parse(JSON.stringify(val || []))
                slides.forEach((slide) => normalizarSlideManual(slide))
                this.slidesLocal = slides
                if (this.slideAtivoIdx >= this.slidesLocal.length && this.slidesLocal.length > 0) {
                    this.$emit('update:slideAtivoIdx', this.slidesLocal.length - 1)
                }
            },
        },
    },

    beforeUnmount() {
        clearTimeout(this.debounceSave)
        clearTimeout(this.debounceBusca)
    },

    methods: {
        obterLabelColuna(campo) {
            return labelColuna(campo)
        },

        tipoLabel(tipo) {
            return TIPOS_SLIDE_LABEL[tipo] || tipo
        },

        resumoFonteSlide(slide) {
            if (!slide || slide.tipo !== 'tabela') return ''
            if (slide.fonte === 'manual') return 'lista manual'
            return labelFonteDados(slide.fonteDados).toLowerCase()
        },

        contagemPainel(fonteDados) {
            return Number(this.contagensPainel?.[fonteDados]) || 0
        },

        selecionarSlide(index) {
            if (!this.slidesLocal.length) return
            const idx = Math.max(0, Math.min(Number(index), this.slidesLocal.length - 1))
            this.$emit('update:slideAtivoIdx', idx)
        },

        onSlidesReordenados() {
            const idAtivo = this.slideAtivo?.id
            this.emitirAtualizacao()
            if (!idAtivo) return
            const novoIdx = this.slidesLocal.findIndex((s) => s.id === idAtivo)
            if (novoIdx >= 0) this.selecionarSlide(novoIdx)
        },

        emitirAtualizacao() {
            this.$emit('atualizar', JSON.parse(JSON.stringify(this.slidesLocal)))
        },

        emitirAtualizacaoDebounced() {
            clearTimeout(this.debounceSave)
            this.debounceSave = setTimeout(() => this.emitirAtualizacao(), 300)
        },

        adicionarSlide(tipo) {
            if (tipo === 'tabela') {
                this.adicionarSlideTabelaPainel()
                return
            }
            const slide = criarSlideVazio(tipo, {
                titulo: tipo === 'texto' ? 'Novo slide' : tipo === 'imagem' ? 'Imagem' : 'Nova tabela',
                fonte: 'manual',
            })
            this.slidesLocal.push(slide)
            this.selecionarSlide(this.slidesLocal.length - 1)
            this.emitirAtualizacao()
        },

        adicionarSlideTabelaPainel() {
            const fonteDados = 'entregas-periodo'
            const slide = criarSlideVazio('tabela', {
                titulo: tituloPadraoFonteDados(fonteDados),
                fonte: 'dinamica',
                fonteDados,
                colunas: [...COLUNAS_TABELA_PADRAO],
            })
            this.slidesLocal.push(slide)
            this.selecionarSlide(this.slidesLocal.length - 1)
            this.emitirAtualizacao()
        },

        adicionarSlideTabelaManual() {
            const slide = criarSlideVazio('tabela', {
                titulo: 'Tabela personalizada',
                fonte: 'manual',
                colunas: [...COLUNAS_PROJETO_PADRAO],
            })
            this.slidesLocal.push(slide)
            this.selecionarSlide(this.slidesLocal.length - 1)
            this.emitirAtualizacao()
        },

        duplicarSlide(index) {
            const orig = this.slidesLocal[index]
            const copia = JSON.parse(JSON.stringify(orig))
            copia.id = gerarSlideId()
            this.slidesLocal.splice(index + 1, 0, copia)
            this.selecionarSlide(index + 1)
            this.emitirAtualizacao()
        },

        removerSlide(index) {
            if (!window.confirm('Remover este slide?')) return
            this.slidesLocal.splice(index, 1)
            this.selecionarSlide(Math.min(this.slideAtivoIdx, Math.max(0, this.slidesLocal.length - 1)))
            this.emitirAtualizacao()
        },

        restaurarPadrao() {
            if (!window.confirm('Substituir todos os slides pelos padrão? Esta ação não pode ser desfeita.')) return
            this.slidesLocal = criarSlidesPadrao({
                periodoInicio: this.periodoInicio,
                periodoFim: this.periodoFim,
            })
            this.selecionarSlide(0)
            this.emitirAtualizacao()
        },

        onFonteChange() {
            if (this.slideAtivo.fonte === 'dinamica') {
                this.slideAtivo.colunas = [...COLUNAS_TABELA_PADRAO]
                if (!this.slideAtivo.fonteDados) {
                    this.slideAtivo.fonteDados = 'entregas-periodo'
                }
                if (tituloDeveSincronizarComFonte(this.slideAtivo.titulo)) {
                    this.slideAtivo.titulo = tituloPadraoFonteDados(this.slideAtivo.fonteDados)
                }
            } else {
                this.slideAtivo.colunas = [...COLUNAS_PROJETO_PADRAO]
            }
            this.emitirAtualizacaoDebounced()
        },

        onFonteDadosChange() {
            if (!this.slideAtivo || this.slideAtivo.fonte !== 'dinamica') return
            if (tituloDeveSincronizarComFonte(this.slideAtivo.titulo)) {
                this.slideAtivo.titulo = tituloPadraoFonteDados(this.slideAtivo.fonteDados)
            }
            this.emitirAtualizacaoDebounced()
        },

        toggleColuna(campo) {
            const cols = [...(this.slideAtivo.colunas || [])]
            const idx = cols.indexOf(campo)
            if (idx >= 0) {
                cols.splice(idx, 1)
            } else {
                cols.push(campo)
            }
            this.slideAtivo.colunas = cols
            this.emitirAtualizacaoDebounced()
        },

        buscarProjetosDebounced() {
            clearTimeout(this.debounceBusca)
            this.debounceBusca = setTimeout(() => this.buscarProjetos(), 350)
        },

        async buscarProjetos() {
            const termo = this.termoBusca.trim()
            if (termo.length < 2) {
                this.resultadosBusca = []
                return
            }
            this.buscandoProjetos = true
            try {
                const data = await serviceProjetos.listarProjetos(null, 1, 20, termo)
                const lista = data?.data || data || []
                this.resultadosBusca = Array.isArray(lista) ? lista : []
            } catch {
                this.resultadosBusca = []
            } finally {
                this.buscandoProjetos = false
            }
        },

        prepararSlideManualParaEdicao() {
            if (!this.slideAtivo || this.slideAtivo.tipo !== 'tabela' || this.slideAtivo.fonte !== 'manual') {
                return []
            }
            if (!Array.isArray(this.slideAtivo.itensManuais)) {
                normalizarSlideManual(this.slideAtivo)
            }
            if (!Array.isArray(this.slideAtivo.itensManuais)) {
                this.slideAtivo.itensManuais = []
            }
            return this.slideAtivo.itensManuais
        },

        itemJaAdicionado(projetoId, entregaId) {
            const pid = Number(projetoId)
            const eid = entregaId != null ? Number(entregaId) : null
            return obterItensManuaisSlide(this.slideAtivo).some(
                (item) => Number(item.projeto_id) === pid
                    && (item.entrega_id != null ? Number(item.entrega_id) : null) === eid,
            )
        },

        adicionarItemManual(projetoId, entregaId) {
            if (this.itemJaAdicionado(projetoId, entregaId)) return
            const itens = this.prepararSlideManualParaEdicao()
            itens.push(criarItemManual(projetoId, entregaId))
            sincronizarProjetoIdsSlide(this.slideAtivo)
            this.emitirAtualizacao()
        },

        fecharModalEntregas() {
            this.modalEntregas = null
        },

        onModalAdicionarEntrega(entregaId) {
            if (!this.modalEntregas) return
            this.adicionarItemManual(this.modalEntregas.projetoId, entregaId)
        },

        onModalAdicionarProjeto() {
            if (!this.modalEntregas) return
            this.adicionarItemManual(this.modalEntregas.projetoId, null)
        },

        async adicionarProjeto(projeto) {
            const id = Number(projeto.id)
            if (!id || !this.slideAtivo) return
            this.$emit('projeto-cache', projeto)
            this.modalEntregas = {
                aberto: true,
                projetoId: id,
                nome: projeto.nome,
                pcm_codigo: projeto.pcm_codigo || '',
                carregando: true,
                entregas: [],
            }
            try {
                const response = await serviceProjetos.getEntregas(id)
                const projetoApi = response?.projetos?.[0]
                const entregas = projetoApi?.entregas || []
                this.$emit('entrega-cache', projetoApi)

                if (entregas.length === 0) {
                    this.adicionarItemManual(id, null)
                    this.fecharModalEntregas()
                    return
                }

                if (entregas.length === 1 && this.precisaEntregaNasColunas) {
                    this.adicionarItemManual(id, entregas[0].id)
                    this.fecharModalEntregas()
                    return
                }

                this.modalEntregas = {
                    aberto: true,
                    projetoId: id,
                    nome: projeto.nome,
                    pcm_codigo: projeto.pcm_codigo || '',
                    carregando: false,
                    entregas,
                }
            } catch {
                window.alert('Não foi possível carregar os pacotes de trabalho deste projeto.')
                this.fecharModalEntregas()
            }
        },

        removerItem(itemId) {
            if (!this.slideAtivo) return
            const itens = this.prepararSlideManualParaEdicao()
            this.slideAtivo.itensManuais = itens.filter((item) => item.id !== itemId)
            sincronizarProjetoIdsSlide(this.slideAtivo)
            this.emitirAtualizacao()
        },

        async onImagemSelecionada(event) {
            const file = event.target.files?.[0]
            event.target.value = ''
            if (!file || !this.slideAtivo) return
            const validacao = validarImagemUpload(file)
            if (!validacao.ok) {
                window.alert(validacao.erro)
                return
            }
            try {
                this.slideAtivo.imagemDataUrl = await lerArquivoComoDataUrl(file)
                this.emitirAtualizacao()
            } catch {
                window.alert('Não foi possível carregar a imagem.')
            }
        },

        removerImagem() {
            if (!this.slideAtivo) return
            this.slideAtivo.imagemDataUrl = ''
            this.emitirAtualizacao()
        },
    },
}
</script>

<style scoped>
.editor-apresentacao {
    width: min(22rem, 100vw);
    max-width: 100%;
    height: 100%;
    background: #fff;
    color: #222;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
}

.editor-cabecalho {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.editor-cabecalho h3 {
    margin: 0;
    font-size: 1rem;
}

.editor-corpo {
    flex: 1;
    overflow-y: auto;
    padding: 0.75rem 1rem;
}

.editor-secao {
    margin-bottom: 1rem;
}

.editor-secao-titulo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    font-size: 0.9rem;
}

.editor-add-botoes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
}

.btn-mini {
    padding: 0.25rem 0.5rem !important;
    font-size: 0.75rem !important;
}

.editor-lista-slides {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.editor-slide-item {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.45rem 0.5rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    cursor: pointer;
    background: #fafafa;
}

.editor-slide-item--ativo {
    border-color: var(--cor-primaria, #00b6b3);
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12));
}

.slide-drag-handle {
    cursor: grab;
    color: #888;
    flex-shrink: 0;
}

.editor-slide-resumo {
    flex: 1;
    font-size: 0.85rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #222;
}

.editor-slide-fonte {
    color: #666;
    font-weight: 400;
    font-size: 0.78rem;
}

.editor-slide-acoes {
    display: flex;
    gap: 0.15rem;
}

.btn-icone {
    background: none;
    border: none;
    padding: 0.2rem 0.35rem;
    cursor: pointer;
    color: #555;
    border-radius: 4px;
}

.btn-icone:hover {
    background: rgba(0, 0, 0, 0.06);
}

.btn-icone--perigo:hover {
    color: #c0392b;
}

.editor-detalhe label {
    display: block;
    margin: 0.65rem 0 0.25rem;
    font-size: 0.82rem;
    font-weight: 600;
    color: #222;
}

.editor-detalhe input[type="text"],
.editor-detalhe input[type="search"],
.editor-detalhe textarea,
.editor-detalhe select {
    width: 100%;
    box-sizing: border-box;
    color: #222;
    background: #fff;
}

.editor-detalhe select option {
    color: #222;
    background: #fff;
}

.editor-busca-hint {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.25rem;
}

.editor-resultados-busca {
    list-style: none;
    margin: 0.35rem 0 0;
    padding: 0;
    max-height: 10rem;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #fff;
}

.editor-resultado-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.4rem 0.55rem !important;
    border: none;
    border-radius: 0 !important;
    background: #fff !important;
    text-align: left;
    cursor: pointer;
    font-size: 0.82rem;
    font-weight: 400 !important;
    color: #222 !important;
}

.editor-resultado-btn span {
    color: #222 !important;
}

.editor-resultado-btn:hover {
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12)) !important;
    color: #111 !important;
}

.editor-projetos-selecionados ul {
    list-style: none;
    margin: 0.35rem 0 0;
    padding: 0;
}

.editor-projetos-selecionados li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.3rem 0;
    font-size: 0.82rem;
    color: #222;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.editor-projetos-label {
    margin: 0.5rem 0 0;
    font-size: 0.82rem;
    font-weight: 600;
}

.editor-secao-adicionar {
    margin-top: 0.85rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.editor-hint--vazio {
    margin-top: 0.35rem;
    font-style: italic;
}

.editor-hint--bloco {
    margin: 0 0 0.5rem;
}

.editor-bloco-painel {
    margin-top: 0.65rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 0.55rem 0.65rem;
}

.editor-bloco-painel legend {
    font-size: 0.82rem;
    font-weight: 600;
    padding: 0 0.25rem;
}

.editor-bloco-opcao {
    display: flex;
    align-items: flex-start;
    gap: 0.45rem;
    padding: 0.4rem 0.35rem;
    margin: 0.15rem 0;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.82rem;
    color: #222;
}

.editor-bloco-opcao:hover {
    background: rgba(0, 0, 0, 0.03);
}

.editor-bloco-opcao--ativa {
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12));
}

.editor-bloco-opcao input {
    margin-top: 0.2rem;
    flex-shrink: 0;
}

.editor-bloco-opcao-texto {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    min-width: 0;
}

.editor-bloco-opcao-titulo {
    font-weight: 600;
    line-height: 1.3;
}

.editor-bloco-contagem {
    font-size: 0.76rem;
    color: #666;
}

.editor-resumo-painel {
    display: flex;
    align-items: flex-start;
    gap: 0.45rem;
    margin-top: 0.55rem;
    padding: 0.55rem 0.65rem;
    border-radius: 6px;
    background: rgba(0, 182, 179, 0.1);
    border: 1px solid rgba(0, 182, 179, 0.2);
    font-size: 0.8rem;
    color: #333;
    line-height: 1.4;
}

.editor-resumo-painel .bi {
    color: var(--cor-primaria-forte, #008a88);
    margin-top: 0.1rem;
    flex-shrink: 0;
}

.editor-colunas {
    margin-top: 0.75rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 0.5rem 0.65rem;
}

.editor-colunas legend {
    font-size: 0.82rem;
    font-weight: 600;
    padding: 0 0.25rem;
}

.editor-colunas-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    max-height: 10rem;
    overflow-y: auto;
}

.editor-colunas-ordenadas {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin-top: 0.35rem;
}

.editor-coluna-ordenada {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    color: #222;
    padding: 0.25rem 0.35rem;
    background: #f5f5f5;
    border-radius: 4px;
}

.editor-coluna-item {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    color: #222;
    cursor: pointer;
}

.editor-hint {
    margin: 0.35rem 0 0;
    font-size: 0.75rem;
    color: #777;
}

.editor-img-preview {
    margin: 0.5rem 0;
    text-align: center;
}

.editor-img-preview img {
    max-width: 100%;
    max-height: 8rem;
    object-fit: contain;
    display: block;
    margin: 0 auto 0.5rem;
}

.editor-rodape {
    padding: 0.75rem 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
